





























































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Ultrassom } from '../../../../back/src/entity/Ultrassom';
import CustomDialog from '../CustomDialog.vue';
import UltrassonsDeGestacaoCard from '../ultrassons/UltrassonsDeGestacaoCard.vue';
import UltrassomForm from '../ultrassons/UltrassomForm.vue';
import TheUltrassomDados from '../ultrassons/TheUltrassomDados.vue';

export default Vue.extend({
  name: 'ThePacientesDadosUltrassom',
  components: {
    CustomDialog,
    UltrassonsDeGestacaoCard,
    UltrassomForm,
    TheUltrassomDados,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      loading: false,
      ultrassons: [] as Ultrassom[],
      dialogUltrassom: false,
      dialogDetalhesUltrassom: false,
      ultrassomSelecionado: null,
    };
  },
  beforeMount() {
    this.buscaUltrassons();
  },
  computed: {
    gestacoesAnteriores() {
      if (!this.paciente.gestacao_atual) {
        return this.paciente.gestacoes;
      }
      const gestacaoAtualId: number = this.paciente.gestacao_atual.id;
      return _.filter(this.paciente.gestacoes, gest => gest.id !== gestacaoAtualId);
    },
    ultrassonsGestacaoAtual() {
      if (this.paciente.gestacao_atual) {
        const gestacaoAtualId: number = this.paciente.gestacao_atual.id;
        return _.filter(this.ultrassons, ultrassom => ultrassom.gestacao_id === gestacaoAtualId);
      }
      return [];
    },
    gestacaoUltrassomSelecionado() {
      if (this.ultrassomSelecionado !== null) {
        return _.find(
          this.paciente.gestacoes,
          item => item.id === this.ultrassomSelecionado.gestacao_id,
        );
      }
      return null;
    },
  },
  methods: {
    abreDialogCriarUltrassom() {
      this.ultrassomSelecionado = null;
      this.dialogUltrassom = true;
    },
    verDetalhesUltrassom(ultrassom: Ultrassom) {
      this.ultrassomSelecionado = ultrassom;
      this.dialogDetalhesUltrassom = true;
    },
    alterarUltrassom(ultrassom: Ultrassom) {
      this.ultrassomSelecionado = ultrassom;
      this.dialogUltrassom = true;
    },
    ultrassonsDeGestacao(gestacaoId: number) {
      return _.filter(this.ultrassons, ultrassom => ultrassom.gestacao_id === gestacaoId);
    },
    novoUltrassom(ultrassom: Ultrassom) {
      this.ultrassons.push(ultrassom);
    },
    atualizaUltrassom(ultrassom: Ultrassom) {
      const index = _.findIndex(
        this.ultrassons as Ultrassom[],
        item => item.id === ultrassom.id,
      );
      if (index >= 0) {
        this.$set(this.ultrassons, index, ultrassom);
      }
    },
    async buscaUltrassons() {
      this.loading = true;
      try {
        const response = await Requester.paciente.ultrassons(this.paciente.id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.ultrassons = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
